// === assets/defer-loader.js ===

// Utilitaire simple
function loadScriptOnce(src, { defer = true, async = false, onload = null } = {}) {
  if (document.querySelector(`script[src="${src}"]`)) return;

  const script = document.createElement('script');
  script.src = src;
  script.defer = defer;
  script.async = async;
  if (onload) script.onload = onload;
  document.body.appendChild(script);
}

// GUIDE OLFACTIF - Masqué quand pas visible
function lazyLoadAllRevenueHunt() {
  const target = document.querySelector('[data-guide_olfactif]');
  if (!target) return;

  const observer = new IntersectionObserver((entries, observer) => {
    if (!entries[0].isIntersecting) return;

    // Script principal
    const script = document.createElement('script');
    script.src = 'https://admin.revenuehunt.com/embed.js?shop=mizensir.myshopify.com';
    script.async = true;
    document.head.appendChild(script);

    observer.disconnect();
  }, {
    rootMargin: '0px',
    threshold: 0.1
  });

  observer.observe(target);
}

document.addEventListener('DOMContentLoaded', lazyLoadAllRevenueHunt);


// HOTJAR - Chargement différé
function loadHotjar() {
  (function(h,o,t,j,a,r){
    h.hj = h.hj || function(){(h.hj.q=h.hj.q||[]).push(arguments)};
    h._hjSettings = { hjid: 3917147, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script'); r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
}


// Déclenchement après 6 secondes ou interaction
deferLoad(loadHotjar, 6000);

